import { Typography } from '@mui/material';
import { EditUsageFormDialog } from 'components/mypage/usage/usage_form_dialog';
import DataBlock from 'components/shared/data/data_block';
import DataCard from 'components/shared/data/data_card';
import DataLabel from 'components/shared/data/data_label';
import { Flex } from 'components/shared/flex';
import { useModal } from 'components/shared/modal';
import ThemedButton from 'components/shared/themed_button';
import { Usage } from 'entities/usage';
import React from 'react';
import { UsageViewModel } from 'view_models/usage';

type UsageDataCardProps = {
  usage: Usage | undefined;
  onCompleteUpdate: (usage?: Usage) => void;
};

const UsageDataCard: React.FC<UsageDataCardProps> = (props) => {
  const editModal = useModal();
  const vm = new UsageViewModel(props.usage || {});

  const handleCompleteUpdate = (usage?: Usage) => {
    editModal.setOpen(false);
    props.onCompleteUpdate(usage);
  };

  return (
    <>
      {props.usage?.canEdit && (
        <EditUsageFormDialog modalState={editModal} usage={props.usage} onComplete={handleCompleteUpdate} />
      )}
      <DataCard>
        <Flex alignItems="center" justifyContent="space-between">
          <Typography variant="h6">利用</Typography>
          {props.usage?.canEdit && (
            <ThemedButton color="primary" onClick={() => editModal.setOpen(true)}>
              編集
            </ThemedButton>
          )}
        </Flex>
        {props.usage ? (
          <DataBlock noBorder>
            <DataLabel label="利用期間" value={vm.getPeriodText()} />
            <DataLabel label="利用者" value={vm.getUserName()} />
            <DataLabel label="利用内容" value={<span style={{ whiteSpace: 'pre-wrap' }}>{vm.getContent()}</span>} />
          </DataBlock>
        ) : (
          <span>利用を選択してください</span>
        )}
      </DataCard>
    </>
  );
};

export default UsageDataCard;
